import {Dispatch} from '@modifi/redux'
import {aShowDialog} from '@modifi/plugin-dialogs'
import {aPush} from '@modifi/router'

import {aFetchCompany} from '../../../../../data/company'
import {ROUTE_ONBOARDING} from '../../../../../routes/constants'
import {ACCOUNT_SETUP_COMPLETE_DIALOG} from '../../../../../dialogs'

export const aSubmitPreOnboarding =
  () =>
  (dispatch: Dispatch): void => {
    dispatch(aFetchCompany())
    dispatch(aPush(ROUTE_ONBOARDING))
    dispatch(aShowDialog(ACCOUNT_SETUP_COMPLETE_DIALOG, {sectionName: 'preunderwriting'}))
  }
